// extracted by mini-css-extract-plugin
export default {"show_area":"Upload_show_area__CchkB","upload_area":"Upload_upload_area__sCa2d","img_wrap":"Upload_img_wrap__4jo+o","icon":"Upload_icon__VW4B-","btn":"Upload_btn__iaGd4"};